// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"757feb5d","710":"e6b2300b","983":"592375bd"}[chunkId] + ".chunk.js";
};